<mat-form-field>
  <input matInput [formControl]="formControl" [placeholder]="placeholder" class="input-title">
</mat-form-field>
<mat-error *ngIf="formControl.hasError('invalid-file-name')">
  {{ formControl.errors['invalid-file-name'].message }}
</mat-error>
<siq-dynamic-component
  [component]="appCriteriaRenderer"
  [data]="activity"
></siq-dynamic-component>